"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const ShowButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    // @ts-ignore
    color: theme?.palette?.text?.link,
}));
const ShowAnalyticsButton = ({ onClick, isShown, }) => (react_1.default.createElement(ShowButton, { "data-testid": "ShowAnalyticsButton", onClick: () => {
        if (onClick) {
            onClick(!isShown);
        }
    } }, isShown ? "Hide Analytics" : "Show Analytics"));
exports.default = ShowAnalyticsButton;
